// @ts-strict-ignore
import { ReleaseStepComponentProps } from '../../typescriptHelpers';
import * as React from 'react';
import { antGrey } from '../styles/globalStyles';
import List from 'antd/lib/list';
import Space from 'antd/lib/space';
import { descriptionForCapabilityOnStep, displayNameForCapability } from '../../helpers';
import Link from 'antd/lib/typography/Link';
import { IntegrationCapability, ReleaseStepType } from '../../types';
import { useSelector } from 'react-redux';
import { selectRecommendedNotConnectedCapabilitiesForStep } from '../../selectors/selectors';
import { RootState } from '../../reducers/reducers';
import Divider from 'antd/lib/divider';
import {
    CapabilityIntegrationsListItem,
    ConnectIntegrationsBannerWrapper,
    DefaultDocsLinkNode,
} from '../ConnectIntegrationsBanner';
import { documentationLinkForCapability } from '../../helpers/displayHelpers';

const ReleaseStepConnectIntegrationsBanner: React.FC<ReleaseStepComponentProps> = (
    props: ReleaseStepComponentProps,
) => {
    const recommendedAndNotConnectedCapabilities = useSelector((state: RootState) =>
        selectRecommendedNotConnectedCapabilitiesForStep(state, props.appId, props.releaseStepType),
    );

    return (
        <ConnectIntegrationsBannerWrapper>
            <List
                itemLayout="vertical"
                dataSource={recommendedAndNotConnectedCapabilities}
                renderItem={(item) => {
                    const description = descriptionForCapabilityOnStep(item, props.releaseStepType);
                    const docsNodeForCapability = docsNodeForCapabilityOnStep(item, props.releaseStepType);
                    return (
                        <CapabilityIntegrationsListItem
                            appId={props.appId}
                            orgId={props.orgId}
                            capability={item}
                            description={description}
                            docsNodeForCapability={docsNodeForCapability}
                        />
                    );
                }}
            />
        </ConnectIntegrationsBannerWrapper>
    );
};

export default ReleaseStepConnectIntegrationsBanner;

const docsNodeForCapabilityOnStep: (capability: IntegrationCapability, step: ReleaseStepType) => React.ReactNode = (
    capability,
    step,
) => {
    switch (capability) {
        case IntegrationCapability.BuildSystem:
            switch (step) {
                case ReleaseStepType.BetaTesting: {
                    const betaCapabilityName = displayNameForCapability(IntegrationCapability.BetaTesting);

                    return (
                        <Space
                            style={{ alignItems: 'stretch' }}
                            split={
                                <Divider type="vertical" style={{ height: '100%', backgroundColor: antGrey.grey5 }} />
                            }
                        >
                            <DefaultDocsLinkNode capability={capability} />
                            <Link
                                href={documentationLinkForCapability(IntegrationCapability.BetaTesting)}
                                target="_blank/"
                            >
                                {betaCapabilityName} docs
                            </Link>
                        </Space>
                    );
                }
                default:
                    return <DefaultDocsLinkNode capability={capability} />;
            }
        default:
            return <DefaultDocsLinkNode capability={capability} />;
    }
};
